export const USER_COLLECTION_SLUG = "users"
export const SHOW_FILES_MENU = true
